import React from 'react';
import PROXI_BRAIN_LOGO from '@/ui/assets/images/proxivideobrainlogo.png';
import { LightShell, LightMark } from '../light-ui';

interface DownloadScreenProps {
  isExpiredToken?: boolean;
  errorMessage?: string;
}

const DownloadScreen: React.FC<DownloadScreenProps> = ({ isExpiredToken = false, errorMessage }) => {
  const goToProxiStudio = () => {
    window?.open('https://www.ProxiAIStudio.com', '_blank');
  };

  return (
    <LightShell scroll>
      <main
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          padding: 'clamp(28px, 8vh, 72px) clamp(20px, 6vw, 80px)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 22, textAlign: 'center', maxWidth: 540 }}>
          <LightMark src={PROXI_BRAIN_LOGO} size={80} />

          <span className="lp-frost-chip" style={{ color: isExpiredToken ? '#b8127b' : 'var(--lp-ink)' }}>
            {isExpiredToken ? 'Invitation expired' : 'Welcome'}
          </span>

          <h1 className="lp-section-heading" style={{ fontSize: 'clamp(28px, 5vw, 42px)' }}>
            {isExpiredToken ? 'This link has run out.' : 'Welcome to Proxi.'}
          </h1>

          <div className="lp-prose" style={{ maxWidth: 460 }}>
            {isExpiredToken ? (
              <>
                {errorMessage && (
                  <p style={{ color: 'var(--lp-ink)', marginBottom: 12 }}>{errorMessage}</p>
                )}
                <p>Your invitation link has expired, but you can still visit Proxi Studio to create and contribute to crowdsourced media.</p>
              </>
            ) : (
              <p>Visit Proxi Studio to create and contribute to crowdsourced media with AI-powered conversations.</p>
            )}
          </div>

          <button
            type="button"
            onClick={goToProxiStudio}
            className="lp-btn lp-btn-primary"
            style={{ marginTop: 4, minWidth: 260 }}
          >
            Go to Proxi Studio
          </button>

          <p style={{
            marginTop: 28,
            fontFamily: 'var(--lp-mono)',
            fontSize: 11,
            letterSpacing: '0.08em',
            color: 'var(--lp-ink-mute)',
          }}>
            Need help? Visit{' '}
            <a href="https://www.ProxiAIStudio.com" target="_blank" rel="noopener noreferrer" className="lp-link">
              Proxi AI Studio
            </a>
            .
          </p>
        </div>
      </main>
    </LightShell>
  );
};

export default DownloadScreen;
